import { Optional } from "common/utils/types";

import { Doctor, SubscriptionFrequency } from ".";

/** matches prescription enum CompoundComplianceRationale */
export enum Rationale {
  REDUCECOMPLIANCE = "REDUCECOMPLIANCE",
  NOTAPPROVED = "NOTAPPROVED",
  UNACHIEVABLE = "UNACHIEVABLE",
  INTOLERANCE = "INTOLERANCE",
}

/** values match choices of enum CompoundComplianceRationaleDetail */
export enum RationaleDetail {
  NEEDSFLAVOR = "NEEDS_FLAVOR",
  NEEDSCOMPOUND = "NEEDS_COMPOUND",
  NEEDSCOMBINEDMEDS = "NEEDS_COMBINED_MEDS",
  SHORTAGE = "SHORTAGE",
  NOCOMMERCIALFORM = "NO_COMMERCIAL_FORM",
  NOCOMMERCIALALTERNATIVE = "NO_COMMERCIAL_ALTERNATIVE",
  TOOSMALL = "TOO_SMALL",
  TOOLARGE = "TOO_LARGE",
  DOSAGEFORMUNSAFE = "DOSAGE_FORM_UNSAFE",
  PROTEINALLERGY = "PROTEIN_ALLERGY",
  TOPICALROUTE = "TOPICAL_ROUTE",
  PRESERVATIVESINTOLERANCE = "PRESERVATIVES_INTOLERANCE",
  DYEALLERGY = "DYE_ALLERGY",
  LACTOSEINTOLERANCE = "LACTOSE_INTOLERANCE",
  XYLITOLINTOLERANCE = "XYLITOL_INTOLERANCE",
}

/** Matches prescriptions BasePrescriptionSerializer */
export interface BasePrescription {
  id: number;
  client_notes: string;
  pharmacist_notes: string;
  allowed_uses: Optional<number>;
  days_supply: Optional<number>;
  remaining_uses: number;
  refills: Optional<number>;
  refills_display: string;
  units_display: string;
  dispensed_units_display: string;
  is_prn: boolean;
  remaining_refills_display: string;
  quantity_per_fill_display: string;
  fills_display: string;
  remaining_fills: number;
  remaining_fills_display: string;
  status: PrescriptionStatus;
  visible_status: VisiblePrescriptionStatus;
  imported_status?: PrescriptionStatus;
  prescribed_on: string;
  prescribed_by: Optional<Doctor>;
  expiration_date: Optional<string>;
  directions: string;
  inactive: boolean;
  quantity: number;
  patient_id: number;
  rationale: Optional<Rationale>;
  rationale_detail: Optional<RationaleDetail>;
  rationale_medical_intention: Optional<string>;
}

/** matches prescriptions PrescriptionLookupSerializer */
export interface PrescriptionLookup extends BasePrescription {
  needs_renewal: boolean;
  subscription_frequency_options: SubscriptionFrequency[];
  subscription_recommended_frequency: SubscriptionFrequency;
}

/** From prescriptions.constants PrescriptionStatus */
export enum PrescriptionStatus {
  Active = "ACTIVE",
  Draft = "DRAFT",
  Declined = "DECLINED",
  Imported = "IMPORTED",
  Inactive = "INACTIVE",
}

/** From prescriptions.constants VisiblePrescriptionStatus */
export enum VisiblePrescriptionStatus {
  Active = "ACTIVE",
  Draft = "DRAFT",
  Declined = "DECLINED",
  ImportedActive = "IMPORTED_ACTIVE",
  ExpiringSoon = "EXPIRING_SOON",
  NoFillsRemaining = "NO_FILLS_REMAINING",
  Expired = "EXPIRED",
  ImportedInactive = "IMPORTED_INACTIVE",
}
